import { render, staticRenderFns } from "./InsufficientPaymentDetail.vue?vue&type=template&id=311b6262&"
import script from "./InsufficientPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./InsufficientPaymentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports